export enum UpdateTicketField {
  None = 0,
  Title = 1,
  Description = 2,
  EntityId = 3,
  Status = 4,
  Priority = 5,
  AssignedToId = 6,
}
